import Link from "next/link"
import classNames from "classnames"
import { getPlayerPageUrl, getTeamPageUrl } from "../../../utils/urls"
import * as ImageConstants from "../../../constants/images"
import Image from "next/image"
import { LocalizedCompetitionSeasonPlayerStatsWithParameterValue } from "../../../types/competitionSeasonPlayerStats"
import { playerRoleToTranslation } from "../../../utils/player"

export function CompetitionSeasonPlayerStanding({
  competitionCalciocomSlug,
  seasonCalciocomSlug,
  playerStandings,
  headerTitle = null,
  unitMeasurement = null,
}: {
  competitionCalciocomSlug: string | null
  seasonCalciocomSlug: string | null
  playerStandings: LocalizedCompetitionSeasonPlayerStatsWithParameterValue[]
  headerTitle?: string | null
  unitMeasurement?: string | null
}) {
  return (
    <div className="hs-block hs-standing" id={"standing"}>
      <h2 className="hs-block-header">{headerTitle === undefined ? "Statistiche Giocatori" : headerTitle}</h2>
      <div className="hs-block hs-statistics hs-statistics--block hs-border-div marginBottom20">
        <div className="module-statistics statistics">
          <div className="stat-giocatori-table-header">
            <p className="sgt-number">#</p>
            <p className="sgt-name">Nome</p>
            <p className="sgt-role">Ruolo</p>
            <p className="sgt-team">Squadra</p>
            <p className="sgt-gol"></p>
          </div>

          {playerStandings.map((player, index) => {
            const value = `${player.parameterValue?.toFixed(2)?.replace(".00", "")}${
              unitMeasurement ? unitMeasurement : ""
            }`

            const isOdd = (index + 1) % 2 === 1
            const playerUrl = getPlayerPageUrl(player.calciocomSlug!)

            return (
              <div
                key={index}
                className={classNames(
                  "entry entry-" + (index + 1),
                  index === 0 ? "first" : index === playerStandings.length - 1 ? "last" : "middle",
                  isOdd ? "odd" : "even",
                )}
              >
                <div className="person_stats-rank">{index + 1}</div>
                <div className="person-image person-image-home person-image-">
                  <Link href={playerUrl}>
                    <a title={player.name}>
                      <Image
                        className={"playerCompetitionStatisticsImage"}
                        src={player.image?.path || ImageConstants.PLAYER_MISSING_IMAGE_PATH}
                        alt={player.name}
                        title={player.name}
                        layout={"intrinsic"}
                        width={60}
                        height={60}
                      />
                    </a>
                  </Link>
                </div>
                <div className="person-name person-name-list">
                  <Link href={playerUrl}>
                    <a title={player.name}>{player.name}</a>
                  </Link>
                </div>
                {player.role ? (
                  <div className="role-name role-name-">{playerRoleToTranslation(player.role)}</div>
                ) : (
                  <div className="role-name role-name- new-placeholder"></div>
                )}
                {player.currentTeam ? (
                  <div className="team-name team-name-">
                    <Link
                      href={getTeamPageUrl(
                        player.currentTeam.calciocomSlug!,
                        competitionCalciocomSlug,
                        seasonCalciocomSlug,
                      )}
                    >
                      <a title={player.currentTeam.name}>{player.currentTeam.name}</a>
                    </Link>
                  </div>
                ) : (
                  <div className="team-name team-name- new-placeholder"></div>
                )}
                <div className="person_stats-playing person_stats-playing-list">{value}</div>
                <div className="person_stats-score person_stats-score-">{value}</div>
                <div className="person_stats-score_penalty person_stats-score_penalty-">{value}</div>
                <div className="person_stats-score person_stats-score_per_playing">{value}</div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
